import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

export function getOnboardingPage(currentPathname: string) {
  if (currentPathname.endsWith(routes.welcomeOnboarding)) {
    return "welcomePage";
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    return "aboutForm";
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    return "categoryForm";
  }
}

export function onboardingNavigate(
  currentPathname: string,
  onboardingForm: Map,
  direction: "next" | "back",
) {
  if (currentPathname.endsWith(routes.welcomeOnboarding)) {
    // only forward
    return routes.aboutOnboarding;
  } else if (currentPathname.endsWith(routes.aboutOnboarding)) {
    if (direction === "back") {
      return routes.welcomeOnboarding;
    }
    if (direction === "next") {
      return routes.categoryOnboarding;
    }
  } else if (currentPathname.endsWith(routes.categoryOnboarding)) {
    if (direction === "back") {
      return routes.aboutOnboarding;
    } else {
      return routes.income;
    }
  } else if (currentPathname.endsWith(routes.income)) {
    if (direction === "back") {
      return routes.categoryOnboarding;
    } else {
      return routes.finalOptIn;
    }
  } else if (currentPathname.endsWith(routes.finalOptIn)) {
    if (direction === "back") {
      return routes.income;
    } else {
      return routes.home;
    }
  }
}
